import { render, staticRenderFns } from "./ItemDetailOpenMarketLayout.vue?vue&type=template&id=55f60b66&scoped=true"
import script from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f60b66",
  null
  
)

export default component.exports